import { useState } from 'react';
import { loadSetting, saveSetting } from '@utils/localStorage';
import { REPORT_RANGE } from '@consts/reports';

export const useRange = (key: string): [REPORT_RANGE, (range: REPORT_RANGE) => void] => {
    const defaultValue = loadSetting(key);
    const [reportRange, setReportRange] = useState<REPORT_RANGE>(defaultValue || REPORT_RANGE.MONTHLY);

    const updateRange = (range: REPORT_RANGE) => {
        saveSetting(key, range);
        setReportRange(range);
    };

    return [reportRange, updateRange];
};
